import styles from "./ProjectVideo.module.css";

const ProjectVideo = (props) => {
  // const video = require(`../../assets/videos/projects/${props.id}.mp4`);
  const image = require(`../../assets/videos/projects/${props.id}.png`);

  return (
    <>
      <div
        className={`${styles["outlined-box"]} ${
          props.currentState === "EXIT" && styles["outlined-box--exit"]
        }`}
      />
      <div
        className={`${styles["video-box"]} ${
          props.currentState === "EXIT" && styles["video-box--exit"]
        }`}>
        {/* <video
          autoPlay
          muted
          loop
          src={video}
          alt="cover"
          className={styles["cover-image"]}
        /> */}
        <img src={image} alt="cover" className={styles["cover-image"]} />
        <div className={styles["overlay"]} />
      </div>
    </>
  );
};

export default ProjectVideo;
